import {
  Button,
  ICONS,
  Loader,
  PageLayout,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useGetEmployeeById } from 'src/hooks/employees/get-employee-by-id.hook';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { EmployeeDetailsEdit } from './components/employee-details-edit';
import { EmployeeDetailsInfo } from './components/employee-details-info';
import { HeaderContainer } from './employee-details.styles';

const EmployeeDetails = () => {
  const { t } = useTranslation(['common', 'employee']);
  const [isEdit, setIsEdit] = useState(false);

  const { id } = useParams();

  const currentCompanyId = useGetCurrentCompanyId();
  const { employee, loading: employeeLoading } = useGetEmployeeById({
    _id: id as string,
    companyId: currentCompanyId,
  });

  const { canEdit } = useUserCanManageDocument({
    createdBy: employee.createdBy || '',
    platformPermission: PLATFORM_PERMISSIONS.employeeManagement,
  });

  return (
    <PageLayout pageTitle={t('employee:labels.employeeProfile')}>
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.employeeDetails')}
        </Typography>
        {!isEdit && canEdit && (
          <Button
            type="primary"
            ghost
            icon={ICONS.editAlt}
            iconColor={PLATFORM_THEME_COLORS.primary.blue}
            onClick={() => setIsEdit(true)}
          >
            {t('common:buttons.edit')}
          </Button>
        )}
      </HeaderContainer>
      {employeeLoading ? (
        <Loader />
      ) : isEdit ? (
        <EmployeeDetailsEdit data={employee} onCancelEdit={() => setIsEdit(false)} />
      ) : (
        <EmployeeDetailsInfo data={employee} />
      )}
    </PageLayout>
  );
};

export default EmployeeDetails;
